module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result12-bafb2ea4a352ce6e71458824a4917194.png";